import { Activity, Droplets, FlaskConical, Thermometer, Wind } from "lucide-react";

import type { WaterParameter } from "@/types/domain";

/** Phase 1 核心水质指标；文案走 i18n（SciencePage:parameters.items.<id>） */
export const WATER_PARAMETERS: WaterParameter[] = [
  { id: "temperature", icon: Thermometer },
  { id: "ph", icon: FlaskConical },
  { id: "turbidity", icon: Droplets },
  { id: "conductivity", icon: Activity },
  { id: "dissolvedOxygen", icon: Wind },
];
